import authInterceptor from "../../AuthInterceptor";

export const LogsAPI = {
    getLogList: () =>
        authInterceptor.get(`ranking-api/log-api/`)
            .then((response) => response.data)
            .catch((error) => error.response),
    getLogFilterList: (bodyData) =>
        authInterceptor.post(`ranking-api/log-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
}